<template >
  <div name="documents">
    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div>
        </div>
      </template>
      <template v-slot:actions>
      </template>
    </FilterBar>

    <div class="table-wrapper">
      <div v-if="errored" class="empty">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>

      <div id="content-area" class="w-11/12 mx-auto" v-else>
        <div
          style="width: 100%; text-align: center"
          class="spin-holder mt-4"
          v-if="loading"
        >
          <i class="spinner fa fa-spinner fa-spin"></i>
          <p>Loading Documents</p>
        </div>

        <div  v-else>
          <div v-if="componentLoaded">
            <table
              class="
                w-full
                mx-auto
                mb-2
                h-10
                pt-2
                align-text-bottom
                bg-white
                rounded
                text-left text-gray-400
              "
            >
              <thead class="bg-gray-100 w-full">
                <tr>
                  <th v-for="(col, index) in columns" :key="index" class="pl-2" v-bind:class="col.css" @click="sort(col.shortcode)">
            {{col.label}} 
            <i v-if="col.shortcode.length > 0" class="fas fa-sort tbh-sort " v-bind:class="col.shortcode === sortBy ? 'text-blue-500' : 'text-gray-400'" ></i>
          </th>
                
                  </tr>

              </thead>
            </table>

            <table
              class="table-wrapper w-full bg-white mx-auto rounded shadow-sm"
            >
              <tbody>
                <tr v-for="(item, index) in orderedDocuments" :key="index">
                  <td
                    @click="displayResource(item)"
                    class="cursor-point w-1/12 pl-2"
                  >
                    <i class="icon fas" v-bind:class="showIcon(item)"></i>
                  </td>
                  <td
                    @click="displayResource(item)"
                    class="cursor-pointer w-2/12"
                  >
                    {{ parseSection(item) }}
                  </td>
                  <td
                    @click="displayResource(item)"
                    class="cursor-pointer w-5/12"
                  >
                    {{ item.title }}
                  </td>
                  <td class="w-2/12 pr-3 capitalize">
                    {{ parseTypeDisplay(item) }}
                  </td>
                  <td @click="displayResource(item)">
                    {{ getDate(item) }}
                  </td>
                
                  <td
                    class="text-xs cursor-pointer pl-4 text-blue-400 w-1/12"
                    align="left"
                  >
                    <template v-if="currentUser.isSubscriber && isOwnedDocument(item)">
                      <i
                        class="fas fa-ellipsis-h ml-4 hover:opacity-75"
                        @click="selectToDelete(item)"
                      ></i>

                      <transition
                        enter-active-class="transition duration-300 ease-out transform"
                        nter-class="-translate-y-3 scale-95 opacity-0"
                        enter-to-class="translate-y-0 scale-100 opacity-100"
                        leave-active-class="transition duration-150 ease-in transform"
                        leave-class="translate-y-0 opacity-100"
                        leave-to-class="-translate-y-3 opacity-0"
                      >
                        <div v-show="showDelete(item)" class="absolute pt-2">
                          <div
                            class="
                              relative
                              py-1
                              bg-white
                              border border-gray-200
                              rounded-md
                              shadow-xl
                            "
                          >
                            <div
                              class="
                                absolute
                                top-0
                                w-4
                                h-4
                                origin-center
                                transform
                                rotate-45
                                translate-x-5
                                -translate-y-2
                                bg-white
                                border-t border-l border-gray-200
                                rounded-sm
                                pointer-events-none
                              "
                            ></div>
                            <div class="relative">
                              <a
                                class="
                                  block
                                  w-full
                                  px-4
                                  py-2
                                  font-medium
                                  text-gray-700
                                  whitespace-no-wrap
                                  hover:bg-gray-100
                                  focus:outline-none
                                  hover:text-gray-900
                                  focus:text-gray-900 focus:shadow-outline
                                  transition
                                  duration-300
                                  ease-in-out
                                "
                                @click="displayResource(item)"
                                >View</a
                              >
                              <a
                                @click="deleteResource(item)"
                                class="
                                  block
                                  w-full
                                  px-4
                                  py-2
                                  font-medium
                                  text-red-500
                                  whitespace-no-wrap
                                  hover:bg-gray-100
                                  focus:outline-none
                                  hover:text-gray-900
                                  focus:text-gray-900 focus:shadow-outline
                                  transition
                                  duration-300
                                  ease-in-out
                                "
                                >Delete</a
                              >
                              <a
                                @click="cancelSelect()"
                                class="
                                  block
                                  w-full
                                  px-4
                                  py-2
                                  font-medium
                                  text-blue-500
                                  whitespace-no-wrap
                                  hover:bg-gray-100
                                  focus:outline-none
                                  hover:text-gray-900
                                  focus:text-gray-900 focus:shadow-outline
                                  transition
                                  duration-300
                                  ease-in-out
                                "
                                >Cancel</a
                              >
                            </div>
                          </div>
                        </div>
                      </transition>
                    </template>
                    <template v-else>
                      <a   v-if="shouldDisplay(index)" 
                      class="ml-4" @click="displayResource(item)"
                        >View</a
                      >
                      <i
                        v-else
                        class="fas fa-lock text-yellow-500 text-lg pl-2"
                      ></i>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="m-5 mx-12" v-else>
            We could not find any data for your given selection.
          </p>
        </div>

        <Pagination
          v-if="componentLoaded"
          :total-pages="totalPages"
          :total="totalResultsCount"
          :current-page="currentPage"
          :has-more-pages="hasMorePages"
          :pageSize="pageSize"
          @pagechanged="showMore"
          class="mt-4 mb-12"
        >
        </Pagination>
      </div>
    </div>

    <modalfile
      :url="loadFilePath()"
      :title="selectedDocument.title"
      :format="selectedDocument.format"
      @close="showModalFile = false"
      v-if="selectedDocument != undefined && showModalFile"
      v-show="showModalFile"
    ></modalfile>

    <modalvideo
      :url="loadVideoPath()"
      @close="showModalVideo = false"
      v-if="selectedDocument != undefined && showModalVideo"
      v-show="showModalVideo"
    ></modalvideo>
    
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { ResourceService } from "@/services/resource.service";
import { fileResourceMixin } from "@/mixins/file-ResourceMixin.js";

import { upgradeMixin } from "@/mixins/upgradeMixin.js";

const modalfile = () => import("@/components/ModalFile.vue");
const modalvideo = () => import("@/components/ModalVideo.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");
const Pagination = () => import("@/components/helpers/Pagination.vue");



export default {
  
  name: "documents",
  mixins: [fileResourceMixin, upgradeMixin],
  props: {},
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    hasMorePages() {
      return this.pagination.has_more === true;
    },
    totalResultsCount() {
      return this.pagination.total_count;
    },
    totalPages() {
      return this.pagination.total_pages;
    },
    typeDropdown() {
      var results = this.typeList;
      return results;
    },
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    orderedDocuments() {
      var vm = this;
      return _.orderBy(vm.resources, [vm.sortBy, "display_order"], [vm.sortDirection]);
    },
    componentLoaded() {
      return this.orderedDocuments.length > 0;
    },
    hasFile() {
      return this.file.name != undefined && this.file.name.length > 3;
    },
    schoolName() {
      return this.currentUser.schoolName;
    },
  },
  data() {
    return {
      loading: true,
      errored: false,

      selectedDocument: {},
      showModalFile: false,
      showModalVideo: false,
      resources: [],
      file: {},
      title: "",
      isMenuVisible: false,
      documentTypes: [],

      search: "",

      page: 1,
      pageSize: 48,
      currentPage: 1,
      pagination: {},

      sortBy: "folder",
      sortDirection: "asc",

      columns: [
         { label: "", shortcode: "", css: "w-1/12" },

        { label: "Section", shortcode: "category.id", css: "w-2/12 text-left" },
        { label: "Title", shortcode: "title", css: "w-5/12" },
        { label: "Type", shortcode: "folder", css: "w-2/12" },
        { label: 'Date', shortcode: 'updated_at', css: 'w-1/12' },
        { label: '', shortcode: '', css: 'w-1/12' },
      ], // columns
                
    };
  },
  watch: {
    $route (to, from){
     if (to.params.type != from.params.type) {
      this.searchResources()
     }
    }
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.searchResources();
  },
  methods: {
    searchResources() {
      this.loading = true

      var typeValue = "dance"
      if (this.$route.params.type != undefined) {
        typeValue = typeValue + "_" + this.$route.params.type
      }

      let type = { value: typeValue , name: typeValue  }
      ResourceService.getLibrary(type, this.search, this.page, this.pageSize)
        .then((response) => this.buildResources(response.data))
        .catch((err) => {
          console.log("resources " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildResources(data) {
      this.resources = data.data;
      this.pagination = data.meta.pagination;
    },
    showIcon(document) {
      const name = document.url;
      let fileExt = name.split(".").pop();
      if (fileExt == "doc") {
        return "fa-file-word";
      } else if (fileExt == "pdf") {
        return "fa-file-pdf";
      } else if (["png", "jpg", "gif"].includes(fileExt)) {
        return "fa-file-image";
      } else if (fileExt == "csv") {
        return "fa-file-csv";
      } else if (["xls", "xlsx"].includes(fileExt)) {
        return "fa-file-exel";
      } else {
        return "fa-file-video";
      }
    },
    parseTypeDisplay(document) {
      if (document.type.key_value === 'school') {
        return "My Document";
      } else if (document.type_id === 'organisation') {
        return "Organisation";
      } else {
        return document.folder;
      }
    },
    displayResource(document) {
      this.selectedDocument = document;
      this.isMenuVisible = false;
      if (document.type == "video") {
        this.showModalVideo = true;
      } else {
        this.showModalFile = true;
      }
    },
    isOwnedDocument(document) {
      return ['school'].includes(document.type.key_value)
    },
    isOrganisationOrOwnedDocument(document) {
      return ['organisation', 'school'].includes(document.type.key_value)
    },
    loadFilePath() {
      let url = this.selectedDocument.url;
      return this.isOrganisationOrOwnedDocument(this.selectedDocument)
        ? url
        : this.selectedDocument.folder + "/" + url;
    },
    loadVideoPath() {
      return this.selectedDocument.file;
    },
    closeAddResource() {
      this.showModalAddition = false;
    },
    failure(err) {
      this.cancelSelect();
      throw new Error(`Resources failure error: ${err}`);
    },
    cancelSelect() {
      this.isMenuVisible = false;
      this.selectedDocument.identifier = undefined;
    },
    getDate(object) {
      return this.isOwnedDocument(object)
        ? moment(object.updated_at).format(moment.HTML5_FMT.DATE)
        : "-";
    },
    parseSection(object) {
      if (object.category == undefined) {
        return "General";
      } else {
        return object.category.name;
      }
    },
    showMore({ page, size }) {
      this.page = page;
      this.currentPage = page;
      this.pageSize = size;
      this.searchResources();
      window.scrollTo(0, 0);
    },
    sort(s) {
      if (s === this.sortBy) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      }
      this.sortBy = s;
    },
    setSearchValue(value, time = 500) {
      let vm = this;
      vm.search = value
      
      if (vm.search.length === 0 || vm.search.length >= 3) {
        clearTimeout(vm.timeout);
        vm.timeout = setTimeout(() => {
          vm.showMore({page: 1, size: vm.pageSize});
        }, time);
      }
    },
    shouldDisplay(index) {
      if (index === 0) {
        return true
      } else if (this.currentUser.isOnTrial) {
        return false
    } else {
        return !this.shouldShowUpgrade
      }
    }
  },
  components: {
    modalfile,
    modalvideo,
    FilterBar,
    Pagination
  },
};
</script>

<style>
i.icon {
  font-size: 18px;
  padding-left: 4px;
  padding-top: 4px;
}
</style>


